import React from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../components/ui/EmptyState';
import Button from '../components/ui/Button';
import { useT } from '../i18n/LocaleContext';

export default function NotFoundPage() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <EmptyState
        icon="✦"
        title={t('pages.not_found.title')}
        body={t('pages.not_found.subtitle')}
        action={<Button variant="gold" onClick={() => navigate('/dashboard')}>{t('nav.dashboard')}</Button>}
      />
    </div>
  );
}
